var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDcDcConverterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.2 92.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.2,0H14C6.3,0,0,6.3,0,14v64.2c0,3.1,1,6,2.7,8.3L86.5,2.7C84.1,1,81.3,0,78.2,0z M23.8,30.3h-13     c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1h13c1.7,0,3.1,1.4,3.1,3.1C26.9,28.9,25.5,30.3,23.8,30.3z M51,30.3H38     c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1h13c1.7,0,3.1,1.4,3.1,3.1C54.1,28.9,52.7,30.3,51,30.3z M51,18H10.8     c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1H51c1.7,0,3.1,1.4,3.1,3.1S52.7,18,51,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.7,6L6,89.7c2.3,1.6,5,2.5,8,2.5h64.2c7.7,0,14-6.3,14-14V14C92.2,11,91.2,8.3,89.7,6z M53.7,80.1h-13         c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1h13c1.7,0,3.1,1.4,3.1,3.1S55.4,80.1,53.7,80.1z M80.9,80.1h-13c-1.7,0-3.1-1.4-3.1-3.1         s1.4-3.1,3.1-3.1h13c1.7,0,3.1,1.4,3.1,3.1S82.6,80.1,80.9,80.1z M80.9,67.8H40.7c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1         h40.2c1.7,0,3.1,1.4,3.1,3.1C83.9,66.4,82.6,67.8,80.9,67.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcDcConverterIcon);
export default __webpack_public_path__ + "static/media/dc-dc-converter-icon.52317b7307b599d1bf7bd0b4e5a796d8.svg";
export { ForwardRef as ReactComponent };